import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ModalControl, LeafIcon } from '@paygreen/paygreen-ui';
import { ModalControlClose } from '../../components';

const ActionsCell = ({ t, selectedCategory, setModalData }) => {
    const actionIconProps = {
        iconSize: 'sm',
        colorPallet: 'status',
        hasBackground: true,
        hasHover: true,
    };

    const handleChange = () => {
        setModalData({
            categoryData: selectedCategory,
            mode: 'edit',
            openMatching: true,
        });
    };

    return (
        <>
            <ModalControl>
                <ModalControlClose action={handleChange}>
                    <LeafIcon
                        htmlTag="button"
                        title={t('matching.table.associateCategory')}
                        marginRight="md"
                        {...actionIconProps}
                        colorStatus="success"
                    />
                </ModalControlClose>
            </ModalControl>
        </>
    );
};

ActionsCell.propTypes = {
    selectedCategory: PropTypes.object,
    setModalData: PropTypes.func,
};

export default withTranslation('common')(ActionsCell);
